export default {"src":"/_next/static/media/chile-flag-rounded.fa3abbe3.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};